<template>
  <section style="margin:18px;">
    <v-flex wrap>
      <v-btn @click="OpenCourseModal">Add Course</v-btn>
      <!-- <v-btn @click="OpenRelatedCourse"> Add Related Course</v-btn> -->
    </v-flex>
    <v-data-table v-model="selected" :headers="headers"
                  :items="GetCourseListDetails"
                  item-key="_id"
                  class="elevation-1"
                  style="margin:5px;">
      <template v-slot:headers="props">
        <tr>
          <th v-for="header in props.headers" :key="header.text">
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr >
          <td class="text-xs-center">{{ props.item.Course_Title }}</td>
          <td class="text-xs-center">{{ FormatCourseTypes(props.item.Course_Types) }}</td>
          <td class="text-xs-center">{{ props.item.Course_Status == 0 ? 'Visible' : 'Not Visible' }}</td>
          <td class="text-xs-center">
            <v-btn color="primary" icon class="btnAction" @click="OpenUpdateCourseDetailsModal(props.item)">
                <v-icon>edit</v-icon>
            </v-btn>
            <v-btn color="error" icon class="btnAction" @click="RemoveCourse(props.item)">
                <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="AddDialog" persistent max-width="750px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-flex v-if="AddUpdate">Add Course Details</v-flex>
          <v-flex v-else>Update Course Details</v-flex>
          <v-btn icon @click="CloseCourseModal">
            <v-icon color="text--secondary">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex>
            <v-select v-model="SelectedCourse" :items="GetCourseList" label="Select Course Category"></v-select>
          </v-flex>
          <v-layout wrap justify-space-around>
            <v-checkbox v-model="Classroom" label="Classroom" class="mx-2"></v-checkbox>
            <v-checkbox v-model="Webinar" label="Online" class="mx-2"></v-checkbox>
            <v-checkbox v-model="Online" label="Self Paced" class="mx-2"></v-checkbox>
          </v-layout>
          <v-flex v-if="NeedBatchTypes.length" style="font-weight: 600; padding-top: 8px;">Batch timing</v-flex>
          <v-flex v-if="ExistingSchedules.length" style="color:#616161; font-size: 13px; padding-bottom: 8px;">
            This course already has a batch. You do not need to enter dates again. Use Add Schedule only if you need another one.
          </v-flex>
          <v-flex v-for="schedule in ExistingSchedules" :key="schedule._id" style="font-size: 13px; padding: 4px 0;">
            {{ CourseTypeLabel(schedule.Schedule_Type) }} —
            {{ schedule.Schedule_Start_Date ? new Date(schedule.Schedule_Start_Date).toDateString() : '' }}
            {{ schedule.Schedule_Time }}
          </v-flex>
          <v-flex v-if="AddUpdate && NeedBatchTypes.length" style="color:#616161; font-size: 13px; padding-bottom: 4px;">
            Required for Classroom and Online when this course has no batch yet. Self Paced does not use a batch.
          </v-flex>
          <v-flex v-for="batchType in NewBatchTypes" :key="batchType.key" style="border: 1px solid #e0e0e0; border-radius: 4px; padding: 12px; margin: 8px 0;">
            <v-flex style="font-weight: 500; padding-bottom: 8px;">{{ batchType.label }} batch</v-flex>
            <v-flex>
              <v-menu :close-on-content-click="false" v-model="DateMenus[batchType.key].registerStart" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="Batches[batchType.key].Register_Start_Date" label="Register Start Date" prepend-icon="event" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="Batches[batchType.key].Register_Start_Date" no-title @input="DateMenus[batchType.key].registerStart = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu :close-on-content-click="false" v-model="DateMenus[batchType.key].registerEnd" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="Batches[batchType.key].Register_End_Date" label="Register End Date" prepend-icon="event" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="Batches[batchType.key].Register_End_Date" no-title @input="DateMenus[batchType.key].registerEnd = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu :close-on-content-click="false" v-model="DateMenus[batchType.key].start" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="Batches[batchType.key].Schedule_Start_Date" label="Course Start Date *" prepend-icon="event" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="Batches[batchType.key].Schedule_Start_Date" no-title @input="DateMenus[batchType.key].start = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu :close-on-content-click="false" v-model="DateMenus[batchType.key].end" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="Batches[batchType.key].Schedule_End_Date" label="Course End Date *" prepend-icon="event" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="Batches[batchType.key].Schedule_End_Date" no-title @input="DateMenus[batchType.key].end = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu :close-on-content-click="false" v-model="DateMenus[batchType.key].time" :nudge-right="40" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="Batches[batchType.key].Schedule_Time" label="Course Time *" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                </template>
                <v-time-picker v-if="DateMenus[batchType.key].time" v-model="Batches[batchType.key].Schedule_Time" full-width @click:minute="DateMenus[batchType.key].time = false"></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-text-field label="Location" v-model="Batches[batchType.key].Schedule_Location"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field :label="batchType.key === 'Classroom' ? 'Address' : 'Meeting link / address'" v-model="Batches[batchType.key].Schedule_Address"></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex>
            <v-text-field label="Course URL" v-model="Course_URL"></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field label="Course Title" v-model="Course_Title"></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field label="Course Keywords" v-model="Course_Keywords"></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field label="Certificate Description" v-model="Certification_Content"></v-text-field>
          </v-flex>
          <v-flex>
            <v-flex style="font-size: 16px;font-weight: 500;padding: 10px;">Course Description : </v-flex>
            <vue-editor id="CourseDescriptionEditor" v-model="Course_Description"></vue-editor>
          </v-flex>
          <v-flex>
            <v-flex style="font-size: 16px;font-weight: 500;padding: 10px;">Course Short Description : </v-flex>
            <vue-editor id="CourseShortDescriptionEditor" v-model="Course_ShortDescription"></vue-editor>
          </v-flex>
          <v-flex>
            <v-flex style="font-size: 16px;font-weight: 500;padding: 10px;">Course Instructions : </v-flex>
            <vue-editor id="Instructioneditor" v-model="Course_Instruction"></vue-editor>
          </v-flex>
          <v-flex v-if="!AddUpdate">
            <v-checkbox v-model="Disable_Course" :label="`${ Disable_Course ? 'Course Not Visible' : 'Course Visible'}`" class="mx-2"></v-checkbox>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat v-if="AddUpdate" @click="AddCourse">Add Course</v-btn>
          <v-btn color="primary" flat v-else @click="UpdateCourse">Update Course</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <app-related-course :dialog='RelatedDialog' @close='CloseCourseModal'></app-related-course>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";
import appRelatedCourse from './dialogs/AddRelatedCourse'
import appRelatedCourseTable from './tables/RelatedCourseTable'
import { CourseTypeLabel, BatchRequiredMessage, CourseIdOf } from '../util/courseTypes'

function emptyBatch() {
  const today = new Date().toISOString().substr(0, 10)
  return {
    Register_Start_Date: today,
    Register_End_Date: today,
    Schedule_Start_Date: today,
    Schedule_End_Date: today,
    Schedule_Time: null,
    Schedule_Location: '',
    Schedule_Address: ''
  }
}

function emptyDateMenus() {
  return { registerStart: false, registerEnd: false, start: false, end: false, time: false }
}

export default {
      components: {
        VueEditor,
        appRelatedCourse,
        appRelatedCourseTable
    },
  data() {
    return {
      AddDialog: false,
      AddUpdate: true,
      headers: [
        { text: "Course Title", value: "Course_Title" },
        { text: "Course Type", value: "Course_Types" },
        { text: "Course Visibility", value: "Course_Status" },
        { text: "Actions" }
      ],
      Course_CategoryId: "",
      Course_Title: "",
      Course_Description: "",
      Course_Keywords: "",
      Course_ShortDescription: "",
      Course_URL: "",
      Course_Instruction : "",
      Certification_Content : "",
      selected: [],
      SelectedCourse: "",
      SelectedCourseDetail: {},
      Classroom: false,
      Online: false,
      Webinar: false,
      RelatedDialog:false,
      Disable_Course : false,
      Batches: {
        Classroom: emptyBatch(),
        Webinar: emptyBatch()
      },
      DateMenus: {
        Classroom: emptyDateMenus(),
        Webinar: emptyDateMenus()
      }
    };
  },
  computed: {
    GetCourseList() {
      return (this.$store.getters.GetCourseList || []).map(x => x["Course_Category_Name"]);
    },
    GetCourseListDetails() {
      return this.$store.getters.GetCourseDetailsList || [];
    },
    NeedBatchTypes() {
      const types = []
      if (this.Classroom) types.push({ key: 'Classroom', label: 'Classroom' })
      if (this.Webinar) types.push({ key: 'Webinar', label: 'Online' })
      return types
    },
    ExistingSchedules() {
      return (this.SelectedCourseDetail && this.SelectedCourseDetail.Schedules) || []
    },
    NewBatchTypes() {
      if (this.ExistingSchedules.length) return []
      return this.NeedBatchTypes
    }
  },
  methods: {
    CourseTypeLabel,
    FormatCourseTypes(types) {
      return (types || []).map(type => CourseTypeLabel(type)).join(", ");
    },
    OpenCourseModal() {
      this.AddDialog = true;
    },
    OpenRelatedCourse(){
      this.RelatedDialog = true
    },
    CloseCourseModal() {
      this.AddDialog = false;
      this.AddUpdate = true;
      this.Course_CategoryId = "";
      this.Course_Title = "";
      this.SelectedCourse = "";
      this.SelectedCourseDetail = {};
      this.Course_Description = "";
      this.Course_Keywords = "";
      this.Course_ShortDescription = "";
      this.Course_URL = "";
      this.Classroom = false;
      this.Online = false;
      this.Webinar = false;
      this.selected = [];
      this.Course_Instruction = ''
      this.Certification_Content = ''
      this.RelatedDialog = false
      this.Batches = {
        Classroom: emptyBatch(),
        Webinar: emptyBatch()
      }
      this.DateMenus = {
        Classroom: emptyDateMenus(),
        Webinar: emptyDateMenus()
      }
    },
    HasBatchData(batch) {
      return !!(batch && batch.Schedule_Start_Date && batch.Schedule_End_Date && batch.Schedule_Time)
    },
    HasExistingBatch(type) {
      const list = (this.SelectedCourseDetail && this.SelectedCourseDetail.Schedules) || []
      return list.some(schedule => {
        const scheduleType = ((schedule && schedule.Schedule_Type) || '').toString()
        if (type === 'Webinar') return ['Webinar', 'Online', 'Live Online'].indexOf(scheduleType) !== -1 || !scheduleType
        return scheduleType === type || !scheduleType
      })
    },
    ValidateRequiredBatches() {
      if (this.ExistingSchedules.length) return null
      if (this.Classroom && !this.HasBatchData(this.Batches.Classroom) && !this.HasExistingBatch('Classroom')) {
        return BatchRequiredMessage('Classroom')
      }
      if (this.Webinar && !this.HasBatchData(this.Batches.Webinar) && !this.HasExistingBatch('Webinar')) {
        return BatchRequiredMessage('Webinar')
      }
      return null
    },
    LoadExistingSchedules(courseId) {
      const embedded = (this.SelectedCourseDetail && this.SelectedCourseDetail.Schedules) || []
      this.$http.post(`${this.$store.getters.GetProductionUrl}/schedules/getschedules`)
        .then(response => {
          const all = response['data']['response'] || []
          const matched = all.filter(schedule => CourseIdOf(schedule) === String(courseId))
          this.$set(this.SelectedCourseDetail, 'Schedules', matched.length ? matched : embedded)
        })
        .catch(() => {
          this.$set(this.SelectedCourseDetail, 'Schedules', embedded)
        })
    },
    SaveCourseBatches(courseId) {
      const jobs = []
      if (this.Classroom && this.HasBatchData(this.Batches.Classroom)) {
        jobs.push(this.PostSchedule(courseId, 'Classroom', this.Batches.Classroom))
      }
      if (this.Webinar && this.HasBatchData(this.Batches.Webinar)) {
        jobs.push(this.PostSchedule(courseId, 'Webinar', this.Batches.Webinar))
      }
      if (!jobs.length) return Promise.resolve()
      return Promise.all(jobs)
    },
    PostSchedule(courseId, scheduleType, batch) {
      return this.$http.post(`${this.$store.getters.GetProductionUrl}/schedules/addschedules`, {
        Course_Id: courseId,
        Schedule_Type: scheduleType,
        Schedule_Start_Date: batch.Schedule_Start_Date,
        Schedule_End_Date: batch.Schedule_End_Date,
        Schedule_Time: batch.Schedule_Time,
        Schedule_Location: batch.Schedule_Location,
        Schedule_Address: batch.Schedule_Address,
        Register_Start_Date: batch.Register_Start_Date,
        Register_End_Date: batch.Register_End_Date
      }).then(response => {
        const saved = response['data'] && response['data']['response']
        if (saved && saved[0]) this.$store.commit('SetIndividualSchedules', saved[0])
        return saved
      })
    },
    AddCourse() {

      let data = {};
      data["Course_CategoryId"] = this.$store.getters.GetCourseList.find(x => x["Course_Category_Name"] == this.SelectedCourse)["_id"];
      data["Course_Title"] = this.Course_Title;
      data["Course_Description"] = this.Course_Description;
      data["Course_Keywords"] = this.Course_Keywords.split(",");
      data["Course_Short_Description"] = this.Course_ShortDescription;
      data["Course_URL"] = this.Course_URL.toLowerCase();
      data["Course_Preview_Video"] = "";
      data["Course_Details"] = [];
      data["Course_Types"] = [];
      data['Course_Instruction'] = this.Course_Instruction
      data['Certification_Content'] = this.Certification_Content
      this.Classroom ? data["Course_Types"].push("Classroom") : "";
      this.Online ? data["Course_Types"].push("Online") : "";
      this.Webinar ? data["Course_Types"].push("Webinar") : "";

      const batchError = this.ValidateRequiredBatches()
      if (batchError) {
        this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: batchError, Color: "red", Close: false });
        return
      }

      if (this.Course_Title && data["Course_Types"] && data["Course_Types"].length > 0 && this.SelectedCourse && this.Course_Description && this.Course_Keywords 
          && this.Course_ShortDescription && this.Course_Instruction && this.Certification_Content) {


        this.$http.post(`${this.$store.getters.GetProductionUrl}/course/addcoursedetails`,data)
          .then(response => {
            const course = response["data"]["response"];
            this.$store.commit("SetIndividualCourseDetails", course);
            return this.SaveCourseBatches(course && course._id).then(() => course)
          })
          .then(() => {
            this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Successfully Added Course Details", Color: "green", Close: false});
            this.CloseCourseModal();
          })
          .catch(err => {

            this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Adding Course Details", Color: "red", Close: false });
          });
      } else {

        this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Fill In All The Details", Color: "red", Close: false });
      }
    },
    OpenUpdateCourseDetailsModal(Item) {

      this.AddUpdate = false;
      this.AddDialog = true;
      this.SelectedCourseDetail = Item;
      this.SelectedCourse = this.$store.getters.GetCourseList.find(x => x["_id"] == Item["Course_CategoryId"])["Course_Category_Name"];
      this.Course_Title = Item["Course_Title"];
      this.Course_Description = Item["Course_Description"];
      this.Course_Instruction = Item['Course_Instruction']
      this.Certification_Content = Item['Certification_Content']
      this.Course_Keywords = Item["Course_Keywords"].join(",");
      this.Course_ShortDescription = Item["Course_Short_Description"];
      this.Classroom = (Item["Course_Types"] || []).includes("Classroom");
      this.Online = (Item["Course_Types"] || []).includes("Online");
      this.Webinar = (Item["Course_Types"] || []).includes("Webinar");
      this.Course_URL = Item["Course_URL"].toLowerCase();
      this.Disable_Course = Item["Course_Status"] == 0 ? false : true 
      this.LoadExistingSchedules(Item["_id"])
    },
    UpdateCourse() {
      let data = {};
      data["id"] = this.SelectedCourseDetail["_id"];
      data["update"] = {};
      data["update"]["Course_CategoryId"] = this.$store.getters.GetCourseList.find(x => x["Course_Category_Name"] == this.SelectedCourse)["_id"];
      data["update"]["Course_Title"] = this.Course_Title;
      data["update"]["Course_Description"] = this.Course_Description;
      data['update']['Course_Instruction'] = this.Course_Instruction
      data['update']['Certification_Content'] = this.Certification_Content
      data["update"]["Course_Keywords"] = this.Course_Keywords.split(",");
      data["update"]["Course_Short_Description"] = this.Course_ShortDescription;
      data["update"]["Course_URL"] = this.Course_URL.toLowerCase();
      data['update']['Course_Status'] = this.Disable_Course ? 1 : 0
      data["update"]["Course_Types"] = [];
      this.Classroom ? data["update"]["Course_Types"].push("Classroom") : "";
      this.Online ? data["update"]["Course_Types"].push("Online") : "";
      this.Webinar ? data["update"]["Course_Types"].push("Webinar") : "";

      const batchError = this.ValidateRequiredBatches()
      if (batchError) {
        this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: batchError, Color: "red", Close: false });
        return
      }

      if (this.SelectedCourseDetail && this.Course_Title && this.Course_Description && this.Course_ShortDescription && this.Course_Instruction && this.Certification_Content) {
        
        this.$http.post(`${this.$store.getters.GetProductionUrl}/course/updatecoursedetails`, data )
                  .then(response => {
                    const course = response["data"]["response"];
                    this.$store.commit("UpdateCourseDetails", course);
                    return this.SaveCourseBatches(course && course._id).then(() => course)
                  })
                  .then(() => {
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Successfully Updated Course Details", Color: "green", Close: false});
                    this.CloseCourseModal();
                  })
                  .catch(err => {

                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Updating Course Details", Color: "red", Close: false });
                  
                  });
      } else {

        this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Failed To Update The Course Details", Color: "red", Close: false });
      }
    },
    RemoveCourse(Item) {

      let Selected_List =  { "Course_Id" : Item['_id']} 

      if(confirm("Do you really want to delete?")){
  
        if (Selected_List && Object.keys(Selected_List).length > 0) {

          this.$http.post(`${this.$store.getters.GetProductionUrl}/course/removecoursedetails`,Selected_List)
                  .then(response => {

                    this.$store.commit("DeleteIndividualCourseDetails", response["data"]["data"]);
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Successfully Deleted Course", Color: "green", Close: false});
                    this.selected = [];
                    this.CloseCourseModal();

                  })
                  .catch(err => {

                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Deleting ",Color: "red",Close: false });
                  
                  });

        } else {

                this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Select Course TO Delete", Color: "red", Close: false });
        }
      }
    }
  },
  mounted() {

    this.$http.get(`${this.$store.getters.GetProductionUrl}/course/getcourselist`)
              .then(response => {

                  this.$store.commit("SetCourseList", response["data"]["response"] || []);
                  return this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`);
              })
              .then(response => {
                  
                  this.$store.commit("SetCourseDetailList", response["data"]["response"] || []);
                  this.$eventHub.$emit("LOADING",'false')
              })
              .catch(err => {
                  this.$eventHub.$emit("LOADING",'false')
                  this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error while Fetching Data", Color: "red", Close: false });
              });
  }
};
</script>
<style>
 #Instructioneditor{
     height: 250px;
 }
  .btnAction{
      margin: 4px;
      border: 1px solid #d3d3d37a;
  }
</style>